import * as React from 'react';

export const LocationIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='13'
    height='17'
    fill='none'
    viewBox='0 0 13 17'
  >
    <path
      stroke='#757575'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.3'
      d='M6.483 8.983a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5'
      clipRule='evenodd'
    ></path>
    <path
      stroke='#757575'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.3'
      d='M6.483 15.65S.65 10.858.65 6.483a5.833 5.833 0 1 1 11.667 0c0 4.375-5.834 9.167-5.834 9.167'
      clipRule='evenodd'
    ></path>
  </svg>
);
